import { ApiError, Logger } from '@bimdata/client';
import showMessage from './show-message.action';

export default (error: Error, message?: string): void => {
  if (!(
    (error instanceof ApiError) &&
    (error.code === 404 || error.code === 403 || error.code === 401)
  )) {
    Logger.error(error);
  }
  showMessage(message || error.message, 'error');
};